<header class="header">
  <div class="header-container">
    <div class="logo-section">
      <img
        src="/img/logo_prosche_y_posi.png"
        alt="アプリロゴ"
        class="logo"
        (click)="navigateToTop()"
        role="button"
        tabindex="0"
        (keydown.enter)="navigateToTop()"
        (keydown.space)="navigateToTop()"
      />
      <img
        src="/img/logo-deliveryplan-s.png"
        alt="納品計画"
        class="deliveryplan-logo"
      />
    </div>
    <div class="user-section">
      @if (helpMenuEnabled) {
      <div
        class="help-menu-wrapper"
        (mouseenter)="onHelpMouseEnter()"
        (mouseleave)="onHelpMouseLeave()"
      >
        <button
          type="button"
          class="help-trigger"
          (click)="toggleHelp()"
          [attr.aria-expanded]="helpOpen"
          aria-haspopup="true"
          aria-label="ヘルプメニューを開く"
          (keydown.enter)="toggleHelp()"
          (keydown.space)="toggleHelp(); $event.preventDefault()"
        >
          <span class="help-trigger-icon" aria-hidden="true">?</span>
        </button>
        @if (helpOpen) {
        <div class="help-dropdown" role="menu">
          @for (item of helpMenuItems; track item.id) { @if (item.enabled) {
          <button
            type="button"
            class="help-dropdown-item"
            role="menuitem"
            (click)="onHelpItemClick(item)"
            (keydown.enter)="onHelpItemClick(item)"
            (keydown.space)="onHelpItemClick(item); $event.preventDefault()"
          >
            {{ item.label }}
          </button>
          } }
        </div>
        }
      </div>
      } @if (userName) {
      <span class="user-name">{{ userName }}</span>
      }
      <!-- <button class="logout-button" (click)="onLogout()">ログアウト</button> -->
    </div>
  </div>
</header>
